export enum ResourceType {
    ROOM = 'ROOM',
    AV = 'AV',
    CAR = 'CAR'
}

export interface IServiceCenterList {
    readonly serviceCenters: IServiceCenter[];
}

export interface IServiceCenter {
    readonly id: number;
    readonly name: string;
    readonly uid: string;
    readonly resources: IResource[];
}

export interface IResource {
    readonly id: number;
    readonly uid: string;
    readonly name: string;
    readonly displayName: string;
    readonly buffer: number;
    readonly colorCode: string | null;
    readonly type: IResourceType;
    readonly room: IRoom;
}

export interface IResourceType {
    readonly id: number;
    readonly name: string;
}

export interface IRoom {
    readonly sittings: number;
    readonly floorDetails: unknown;
    readonly isPrivateOffice: boolean;
    readonly seats: number;
}
